import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { BrowserHistoryReplace } from '../../shared/routing/BrowserHistoryReplace';

import { MessageTemplateEdit } from './components/EditMessageTemplate';
import { MessageTemplateList } from './components/List';
import { MessageTemplateNavbar } from './components/Navbar';
import { MessageTemplateNew } from './components/NewMessageTemplate';

import { MessageTemplates as MessageTemplatesLayout } from './';

export const MessageTemplateRoute = (
    <Route
        path="/templates"
        render={({ match }) => (
            <React.Fragment>
                <Route path={`${match.url}/list`} component={MessageTemplateNavbar} />
                <MessageTemplatesLayout>
                    <Switch>
                        <Route path={`${match.url}/list`} render={() => <MessageTemplateList />} />
                        <Route path={`${match.url}/new`} render={() => <MessageTemplateNew />} />
                        <Route
                            path={`${match.url}/edit/:messageTemplateId`}
                            render={() => <MessageTemplateEdit />}
                        />
                        <Route render={() => <BrowserHistoryReplace to={`${match.url}/list`} />} />
                    </Switch>
                </MessageTemplatesLayout>
            </React.Fragment>
        )}
    />
);
